export class NumberUtils {
  static formatMonetaire(montant: number): string {
    if (montant === 0) return "0,00 €";

    const absValue = Math.abs(montant);

    let formatted: string;

    if (absValue >= 1) {
      // Format standard avec 2 décimales et séparateur français
      formatted = montant.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else if (absValue >= 0.01) {
      // Format avec 2 à 4 décimales pour petites valeurs
      formatted = montant.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      });
    } else {
      // Très petite valeur : jusqu’à 6 décimales, pas d’arrondi brutal
      formatted = montant.toLocaleString("fr-FR", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 6,
      });
    }

    return `${formatted} €`;
  }

  static formatNombreReprésentatif(montant: number): string {
    if (montant === 0) return "0";

    const absValue = Math.abs(montant);
    let formatted: string;

    if (Number.isInteger(montant)) {
      // Entier : aucun chiffre après la virgule
      formatted = montant.toLocaleString("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    } else if (absValue >= 1) {
      // Affiche 2 décimales
      formatted = montant.toLocaleString("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    } else if (absValue >= 0.01) {
      // Affiche 2 à 4 décimales
      formatted = montant.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
      });
    } else {
      // Très petites valeurs : jusqu’à 6 décimales
      formatted = montant.toLocaleString("fr-FR", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 6,
      });
    }

    return formatted;
  }
}

/**
 * Arrondi intelligent basé sur la magnitude (même logique que le pipe numberSig).
 * Retourne un nombre, pas un string formaté.
 */
export function roundSig(n: number): number {
  if (!Number.isFinite(n) || n === 0) return n;
  const abs = Math.abs(n);
  let decimals: number;
  if (abs >= 100) decimals = 2;
  else if (abs >= 10) decimals = 3;
  else if (abs >= 1) decimals = 4;
  else {
    const exp = Math.floor(Math.log10(abs));
    decimals = Math.max(0, 4 - exp);
  }
  const factor = Math.pow(10, decimals);
  return Math.round(n * factor) / factor;
}

export function parseNumber(value): number {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    return Number(value.replace(",", "."));
  }
  return Number(value);
}
